module.exports = __webpack_public_path__ + "static/media/upload-img.39a873e9.svg";